import { render, staticRenderFns } from "./VerFaq.vue?vue&type=template&id=54fa82f6&scoped=true&"
import script from "./VerFaq.vue?vue&type=script&lang=js&"
export * from "./VerFaq.vue?vue&type=script&lang=js&"
import style0 from "./VerFaq.vue?vue&type=style&index=0&id=54fa82f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fa82f6",
  null
  
)

export default component.exports